module.exports = __webpack_public_path__ + "static/img/expand-the-possibilities__small.7d19d01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/primary/expand-the-possibilities__small.jpg
// module id = skb+
// module chunks = 1